module.exports = __webpack_public_path__ + "img/code-sandbox-square.52c9075a.svg";